import {Color} from '@benchling/nucleus-ui';
import {createStyles, Text} from '@mantine/core';
import React from 'react';
import {NodeProps} from 'reactflow';
import {Node} from 'reactflow';

import getTestProps from 'test/lib/cypress/getTestProps';
import {BenchlingNode} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNode';
import {COMMON_NODE_WIDTH} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeDesignConstants';

export const PROCEDURE_RUN_DESIGN_FLOWCHART_NODE_TYPE = 'procedureRunDesignFlowchartNode';

export const FALLBACK_NODE_WIDTH = COMMON_NODE_WIDTH;
export const FALLBACK_NODE_HEIGHT = 50; // best-effort static fallback; see TODO (BNCH-156222)

export interface ProcedureRunDesignFlowchartNodeData {
  conditionName: string;
  replicateNumber: number;
  conditionDescription?: string;
}

export function createProcedureRunDesignFlowchartNode({
  conditionIndex,
  replicateIndex,
  methodId,
  conditionName,
  replicateNumber,
  conditionDescription,
}: {
  conditionIndex: number;
  replicateIndex: number;
  methodId: string;
  conditionName: string;
  replicateNumber: number;
  conditionDescription?: string;
}): Node<ProcedureRunDesignFlowchartNodeData> {
  return {
    id: `${conditionIndex}-${replicateIndex}-${methodId}`,
    type: PROCEDURE_RUN_DESIGN_FLOWCHART_NODE_TYPE,
    data: {
      conditionName,
      replicateNumber,
      conditionDescription,
    },
    style: {
      width: FALLBACK_NODE_WIDTH,
      height: FALLBACK_NODE_HEIGHT,
    },
    position: {
      x: 0,
      y: 0,
    },
    selectable: false,
    deletable: false,
    draggable: false,
    connectable: false,
  };
}

export default function ProcedureRunDesignFlowchartNode(
  props: NodeProps<ProcedureRunDesignFlowchartNodeData>
): JSX.Element {
  const {classes} = useStyles();
  const {data} = props;
  return (
    <BenchlingNode isSelectable={false} w="200px" dataTestAttrs={{element: 'root'}}>
      <BenchlingNode.Header
        {...getTestProps({component: 'ProcedureRunDesignFlowchartNode', element: 'header'})}
      >
        <Text className={classes.conditionReplicate}>
          {`${data.conditionName} - ${data.replicateNumber}`}
        </Text>
        {data.conditionDescription ? (
          <Text className={classes.description}>{data.conditionDescription}</Text>
        ) : null}
      </BenchlingNode.Header>
      {/* TODO (BNCH-153699): Include sections with varied parameters */}
    </BenchlingNode>
  );
}

const useStyles = createStyles((theme) => ({
  conditionReplicate: {
    fontWeight: 600,
    fontSize: theme.fontSizes.sm,
    lineHeight: '16px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  description: {
    color: Color.GRAY_600,
    fontSize: theme.fontSizes.xxs,
    lineHeight: '14px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
}));
